import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    OnDestroy,
    Input,
    ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";

import { SeoLinks } from "@hermes/fragments/seo-links";
import { GridFacade } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-seo-pagination-links",
    templateUrl: "./seo-pagination-links.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeoPaginationLinksComponent implements OnInit, OnDestroy {
    @Input()
    public links!: string[];
    public seoLinks: SeoLinks = [];

    public currentPageNumber!: number;
    private subscription: Subscription = new Subscription();

    constructor(
        private cd: ChangeDetectorRef,
        private gridFacade: GridFacade,
    ) {}

    public ngOnInit(): void {
        this.subscription.add(
            this.gridFacade.pageNumber$.subscribe((pageNumber: number) => {
                this.currentPageNumber = Number(pageNumber);
                this.seoLinks = this.links.map(
                    (link: string, index: number) => ({
                        path: link,
                        label: `${index + 1}`,
                        isDisplayed: this.shouldAddLink(index),
                    }),
                );
                this.cd.markForCheck();
            }),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private shouldAddLink(currentLinkPageNumber: number): boolean {
        // Don't add current page link
        if (currentLinkPageNumber === this.currentPageNumber - 1) {
            return false;
        }
        // When it is the last page
        // OR ((currentLinkPageNumber + 1) modulo 12) give 0
        // Then link should be added
        else if (
            currentLinkPageNumber === this.currentPageNumber - 2 ||
            currentLinkPageNumber === this.links.length - 1 ||
            // Display links 12, 24, 36 is exist
            (currentLinkPageNumber + 1) % 12 === 0
        ) {
            return true;
        }
        // When it is not the first page
        // First page link should be always added
        else if (currentLinkPageNumber < this.currentPageNumber - 1) {
            return currentLinkPageNumber === 0;
        }
        // Add next 4 pages links
        else if (currentLinkPageNumber < this.currentPageNumber + 4) {
            return true;
        }
        return false;
    }
}
